import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileNavbar from './components/MobileNavbar';
import ScrollToTop from './components/ScrollToTop';
import AppRouter from './routes';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import apiClient from './api/api';
import './App.css';

import { Toaster } from 'react-hot-toast';

function App() {
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWorkers = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get('/workers');
        setWorkers(response.data.workers);
      } catch (err) {
        console.error("Failed to fetch workers:", err);
        setError("Failed to load workers. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchWorkers();
  }, []);

  return (
    <AuthProvider>
      <SocketProvider>
        <Router>
          <Toaster position="top-right" reverseOrder={false} />
          <ScrollToTop />
          <div className="App pb-16 md:pb-0">
            <Header />
            <AppRouter workers={workers} workersLoading={loading} workersError={error} />
            <Footer />
            <MobileNavbar />
          </div>
        </Router>
      </SocketProvider>
    </AuthProvider>
  );
}

export default App;
